import { defineMessages } from 'react-intl';


export default defineMessages({
    TERM_MESSAGE: {
        id: 'mtg-common.Amortization.termMessage',
        defaultMessage: '{term}-year',
    },
});